<div id="nav-content" class="grid-col-12 customResponsiveFormlyElements">

  <sds-side-toolbar [responsiveButtonText]="'Navigate To'"
                    [responsiveDialogOptions]="responsiveDialogOptions"
                    [dialogTitleText]="'Navigate To'"
                    [backButtonAria]="'Close'"
                    [responsiveSize] ="1023"
                    >
    <ng-template>

      <div class="sds-card" >
        <div class="sds-card__body sds-card__body--accent-cool" id="panelBody">
          <sds-selection-panel [model]="moduleData"
                               [currentSelection]="selectedPanel"
                               (panelSelected)="changeModule($event)">
          </sds-selection-panel>
        </div>
      </div>

    </ng-template>
  </sds-side-toolbar>

</div>
